export default __webpack_public_path__ + "static/media/39k.df7fee83.yaml";